export default {
  buttons: {
    next: 'Weiter',
    next_to: '>',
    nextWithoutBooth: "Weiter ohne Standbaupaket",
    order_new_booth: 'Neuen Messestand bestellen',
    order_new_articles: 'Zusatzartikel bestellen',
    prev: 'Zurück',
    prev_to: '<',
    remove: 'Entfernen',
    select: 'Auswählen',
    submit: 'Abschicken',
    show: 'Anzeigen',
    remove_booth: 'Standbaupaket aus Warenkorb entfernen'
  },
  basket: {
    title: "Warenkorb",
    articleTitle: "Artikel",
    article_summary: "Artikelzusammenfassung",
    booth_label: 'Standbeschriftung',
    booth_package: 'Standbaupaket',
    booth_type: 'Standart',
    disposal_costs: 'Entsorgungspauschale',
    late_delivery: 'Spätbestelleraufschlag',
    media_package: 'Komunikationspaket',
    item: 'Position',
    netPrice: 'Netto Preis',
    vatPrice: 'MWSt.',
    price: 'Preis',
    price_in: 'Preis in EUR',
    rent: 'Mietpreis',
    size: 'Maße',
    total: "Gesamt Netto",
    total_gross: "Gesamt Brutto (inkl. [vatRate]% MwSt)",
    total_gross_summary: "Gesamt Brutto (inkl. MwSt)",
    carpetColor: "Teppich Farbe",
    squareMeter: "m2"
  },
  boothTypes: {
    corner_left: 'Eckstand (links)',
    corner_right: 'Eckstand (rechts)',
    head: 'Kopfstand',
    island: 'Inselstand',
    row: 'Reihenstand',
    corner: 'Eckstand',
    unknown: 'Unbekannt'
  },
  checklist: {
    size_set: "Bitte geben Sie Ihre gebuchte Standmaße an",
    booth_typ_set: "Art des Stands wählen",
    booth_package_set: "Bitte wählen Sie Ihre gebuchte Standart aus",
    address_set: "Adresse angegeben",
    payment_address_set: "Rechnungsadresse angegeben",
    data_set: "Name, Firma und E-Mail-Adresse angegeben",
    company_set: "Halle und Messestandnummer angegeben",
    hall_name_set: "Hall angegeben",
    booth_number_set: "Messestandnummer angegeben",
    vat_set: "Die Ust. ID ist korrekt",
    vat_not_set: "Die Ust. ID ist nicht korrekt",
    passwords: "Passwörter müssen übereinstimmen",
    booth_label: 'Standbeschriftung benötigt',
    order_number: 'PO/Auftragsnummer wird benötigt',
    minimum_checkout: 'Bitte wählen Sie mindestens ein Standpaket oder einen Zusatzartikel aus'
  },
  descriptions: {
    select_new_booth_or_articles: 'Bitte wählen Sie aus, ob Sie einen neuen Messestand oder zusätzliche Artikel bestellen wollen.',
    select_booth: 'Wählen Sie den entsprechenden Stand aus, für den Sie zusätzliche Artikel bestellen wollen:'
  },
  errors: {
    occurred: "Fehler aufgetreten!",
    please_try_again: "Bitte versuchen Sie noch einmal. Sollte der Fehler häufiger auftreten, kontaktieren Sie bitte den Support.",
    invalid_credentials: "Die Zugangsdaten sind ungültig, bitte überprüfen Sie Ihre Angaben.",
    registration_failed: "Registrierung fehlgeschlagen. Bitte überprüfen Sie Ihre Angaben.",
    email_taken: "Registrierung fehlgeschlagen. Die E-Mail-Adresse wird bereits verwendet.",
    closed: 'Der Shop ist für diese Messe geschlossen. Wir können leider keine Bestellungen mehr akzeptieren.',
    data_invalid: "Die angebenen Daten weisen Fehler auf. Bitte überprüfen Sie die folgenden Punkte:",
    email_required: "Die E-Mail-Adresse fehlt.",
    name_required: "Der Name des Ansprechpartners fehlt.",
    name_min: "Der Name des Ansprechpartners muss mindestens 2 Zeichen lang sein.",
    name_max: "Der Name des Ansprechpartners darf nicht länger als 191 Zeichen sein.",
    street_name_required: "Der Straßenname fehlt.",
    street_name_max: "Der Straßenname darf nicht länger als 191 Zeichen sein.",
    place_required: "Die Ortsangabe fehlt.",
    place_max: "Der Ortsname darf nicht länger als 191 Zeichen sein.",
    zip_required: "Die Postleitzahl fehlt.",
    zip_max: "Die Postleitzahl darf nicht länger als 10 Zeichen sein.",
    street_number_max: "Die Hausnummer darf nicht länger als 10 Zeichen sein.",
    phone_max: "Die Telefonnummer darf nicht länger als 191 Zeichen sein.",
    company_max: "Der Firmenname darf nicht länger als 191 Zeichen sein.",
    vat_id_max: "Die Ust. ID ist nicht korrekt",
    vat_id: "Die Ust. ID ist nicht korrekt",
    basket_depth_numeric: "Die Tiefenangabe des Stands ist nicht numerisch.",
    basket_width_numeric: "Die Breitenangebe des Stands ist nicht numerisch.",
    name_min: "Der Name für die Rechnungsanschrift muss mindestens 2 Zeichen lang sein.",
    name_max: "Der Name für die Rechnungsanschrift darf nicht länger als 191 Zeichen sein.",
    street_name_max: "Der Straßenname für die Rechnungsanschrift darf nicht länger als 191 Zeichen sein.",
    street_number_max: "Die Hausnummer für die Rechnungsanschrift darf nicht länger als 10 Zeichen sein.",
    zip_max: "Die Postleitzahl für die Rechnungsanschrift darf nicht länger als 10 Zeichen sein.",
    place_max: "Der Ortsname für die Rechnungsanschrift darf nicht länger als 191 Zeichen sein.",
    confirmed_business_customer: "Bestätigung, das Sie ein Unternehmer im Sinne von §14 BGB sind, wird benötigt.",
    order_number: "PO/Auftragsnummer wird benötigt.",
    use_order_number: "Bitte wählen Sie <b>Ja</b> oder <b>Nein</b> aus.",
    session_timeout: "Ihre Sitzung ist abgelaufen. Bitte laden Sie die Seite erneut.",
    exhibition_hall_regex: "Bitte verwenden Sie nur lateinische Buchstaben, Nummern, Leerzeichen und die folgenden Sonderzeichen:+_-.,/&#",
    exhibition_booth_number_regex: "Bitte verwenden Sie nur lateinische Buchstaben, Nummern, Leerzeichen und die folgenden Sonderzeichen:+_-.,/&#",
  },
  forms: {
    placeholders: {
      name: "Name des Ansprechpartners",
      bill_name : "Name des Ansprechpartners (Rechnung)",
      email: "E-Mail-Adresse",
      company: "Name der Firma",
      company_and_legal_form: "Name der Firma und Rechtsform",
      legal_form: "Rechtsform",
      vat_id: "Ust. ID der Firma",
      street_name: 'Straße',
      street_number: 'Nr.',
      zip: 'z.B. 12345',
      place: 'Name der Stadt',
      country: "Land",
      phone: 'Telefonnr. z.B. 0123 456 7890',
      hall: "Name der Messe-Halle, z.B. Halle B",
      booth_number: "Nummer des Messestandes, z.B. B7",
      comment: "Fragen, Anmerkungen, ...",
      password: "Passwort, mindestens 8 Zeichen",
      passwordConfirmation: "Passwort bestätigen",
      check: "Wird geprüft..."
    },
    name: "Name",
    country: "Land",
    bill_name : "Name (Rechnung)",
    email: "E-Mail",
    company: "Name der Firma",
    company_and_legal_form: "Name der Firma und Rechtsform",
    legal_form: "Rechtsform",
    vat_id: "Ust. ID",
    bill_company : "Name (Rechnung)",
    street_name: 'Straße / Nr.',
    bill_street_name: 'Straße / Nr.',
    zip_place: 'Postleitzahl / Ort',
    bill_zip_place: 'Postleitzahl / Ort',
    phone: 'Telefon',
    hall: "Messe-Halle",
    booth_number: "Messestandnummer",
    comment: "Anmerkungen",
    password: "Passwort",
    passwordConfirmation: "Passwort wdh.",
    order_number: "PO/Auftragsnummer",
    use_order_number: "Wird eine PO/Auftragsnummer verwendet",
    order_number_notice: "Hinweis: Bitte beachten Sie, dass die nachträgliche Berücksichtigung von PO/Auftragsnummer eine neue Rechnungsstellung zur Folge haben und die mit einer Aufwandspauschale von 25€ berechnet wird!",
    bill_address_notice: "Hinweis: Bitte beachten Sie, dass nach Rechnungsstellung bei nachträglicher Änderung des Rechnungsempfängers 25€ Aufwandspauschale berechnet werden!"
  },
  labels: {
    site_notice: 'Impressum',
    privacy: 'Datenschutzhinweise',
    general_terms: 'Allgemeine Geschäftsbedinungen',
    description: 'Beschreibung',
    select_booth_type: 'Bitte wählen Sie Ihre gebuchte Standart aus',
    select_booth_package: 'Standpaketauswahl',
    set_size: 'Bitte geben Sie Ihre gebuchte Standmaße an',
    depth: 'Tiefe',
    width: 'Breite',
    sqm: 'm²',
    carpet_color_selection: 'Teppich-Farbauswahl',
    booth_package: 'Standbaupaket: {0}',
    booth_label: 'Standbeschriftung',
    booth_label_characters_inclusive: '{0} Zeichen frei',
    alternative_packages: 'Alternativen',
    category: 'Kategorie',
    exhibition_hall: 'Messe-Halle',
    exhibition_booth_number: 'Messestandnummer',
    email: 'E-Mail-Adresse',
    phone: 'Telefon',
    payment_address: 'Rechnungsadresse',
    address: 'Adresse',
    notice: 'Hinweis',
    per_unit: 'Stück',
    search: 'Suche',
    select_place: 'Standort auswählen',
    select_exhibition: 'Veranstaltung auswählen',
    no_results: 'Keine Treffer gefunden.',
    no_entries: 'Es sind zur Zeit keine anstehenden Messen eingetragen.',
    requests_overview: 'Bestellungsübersicht',
    summary: 'Zusammenfassung',
    order_number: 'PO/Auftragsnummer',
    documents: 'Dokumente',
    request_in_progress: "Bitte haben Sie etwas geduld, Ihre Bestellung wird verarbeitet.",
    checklist: "Checkliste",
    contact_data: "Abschließende Informationen",
    login: "Anmelden",
    register: "Registrierung",
    guest: "Als Gast fortfahren",
    submit_request: "Kostenpflichtig Bestellen",
    add_bill_address: "abweichende Rechnungsadresse angeben",
    remove_bill_address: "Keine abweichende Rechnungsadresse eingeben",
    already_customer: "Haben Sie bereits ein Kundenkonto?",
    no_account: "Noch kein Kundenkonto?",
    general_terms_submit: "Durch das Absenden Ihrer Bestellung, akzeptieren Sie unsere <a href='[path_to_general_terms]' target='_blank'>Allgemeinen Geschäftsbedinungen</a>.",
    confirmed_business_customer: "Ich bestätige, dass ich ein Unternehmer im Sinne von §14 BGB bin.",
    yes: "Ja",
    no: "Nein",
    different_billing_address: 'Abweichende Rechnungsadresse',
    client: 'Auftraggeber/Rechnungsempfänger',
    password_reset: 'Passwort vergessen?',
    printable: 'Bedruckbar',
    inclusive_abbreviation: 'inkl.'
  },
  tab: {
    key_data: "Standdaten",
    booth_selection: 'Standpaketauswahl',
    booth_set_up: 'Konfiguration',
    articles: 'Zusatzartikel',
    summary: 'Zusammenfassung',
    submit: 'Abschluss',
    prints: 'Drucke'
  },
  success: {
    title: "Vielen Dank für Ihre Bestellung!",
    message: "Ihre Bestellung ist eingegangen. Sie erhalten in Kürze eine Eingangsbestätigung der Bestellung an die angebene E-Mail-Adresse."
  },
  summary: {
    package: "Systemstand",
    articles: "Zusatzausstattung",
    other_costs: "Standflächenmiete und obligatorische Leistungen",
    other_costs_notice: "wird separat vom Veranstalter einmalig pro Stand berechnet"
  },
  misc: {
    power: "inklusive Stromanschluss (3kW)"
  },
  urls: {
    site_notice: "/impressum",
    privacy: "/datenschutz",
    general_terms: "/terms/LUECO-Allgemeine-Geschaeftsbedingungen.pdf"
  },
  table: {
    id: "# ID",
    exhibition: "Messe",
    booth: "Ausgewähltes Standpaket",
    status: "Status",
    created_at: "Erstellt am",
    updated_at: "Letzte Änderung",
    options: "Optionen"
  },
  booth_articles: {
    per_unit: "/Stk."
  },
  categories: {
    all: "Alle"
  },
  article_not_available: "Nicht verfügbar",
  placeholders: {
    booth_label: 'Pflichtfeld',
  },
  contact: {
    title: 'Kontakt'
  },
  toast: {
    title: {
      success: 'Erfolgreich',
      error: 'Fehler aufgetreten',
      warning: 'Warnung',
      info: 'Hinweis'
    },
    message: {
      error: 'Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.'
    },
    warnings: {
      too_large: 'Die hochgeladene Datei übersteigt die Begrenzung von 500 MB.'
    }
  },
  print_cloud: {
    indicator: {
      delete_upload: 'Upload wird gelöscht',
      mark_as_user_ready: 'Vorgang wird als "Fertig" markiert',
      submit_order: 'Bestellungsanfrage wird verarbeitet',
      upload: 'Datei wird hochgeladen',
    }
  },
  configurator: {
    alerts: {
      success: {
        files_are_being_processed: 'Ihre Dateien werden jetzt von unserem Team bearbeitet.'
      }
    },
    buttons: {
      add: 'Hinzufügen',
      add_articles: 'Artikel hinzufügen',
      add_graphic_design: 'Graf. Gestaltung hinzufügen',
      add_lettering: 'Standbeschriftung hinzufügen',
      add_more_printable_articles: 'Weitere bedruckbare Artikel hinzufügen',
      add_print: 'Druck hinzufügen',
      cancel: 'Abbrechen',
      close: 'Schließen',
      delete: 'Löschen',
      delete_graphic_file: 'Grafikdatei löschen',
      download_all_files: 'Alle Dateien herunterladen',
      edit_lettering: 'Standbeschriftung bearbeiten',
      mark_as_ready: 'Druckaufträge als "Fertig" markieren',
      mark_as_order: 'Druckaufträge bestellen',
      no: 'Nein',
      ok: 'Ok',
      remove_from_basket: 'Aus Warenkorb entfernen',
      update: 'Aktualisieren',
      upload: 'Hochladen',
      upload_booth_draft: 'Grafikablauf hochladen',
      upload_graphic_file: 'Grafikdatei hochladen',
      upload_now: 'Jetzt hochladen',
      yes: 'Ja'
    },
    descriptions: {
      all_required_files_uploaded: 'Sie haben alle benötigten Dateien hochgeladen; Sie können den Vorgang jetzt als "Fertig" markieren.',
      contact_general: 'Bei allgemeinen Fragen zum Shop schreiben Sie bitte eine E-Mail an shop[at]lueco.de.',
      contact_order: 'Nach Erhalt Ihrer Auftragsbestätigung haben Sie einen festen Ansprechpartner, der Ihnen gern alle Detailfragen zu Ihrem Auftrag beantworten wird!',
      external_print_cloud_introduction: 'Willkommen in der Druckverwaltung von Lüco. Bitte laden Sie für jeden Druck ein Logo oder eine Grafik hoch. Wenn Sie alle Dateien hochgeladen haben, markieren Sie Ihren Vorgang als "Fertig", so dass wir mit dem Druck beginnen können. Wenn Sie einen Fehler entdecken und Ihren Vorgang schon als "Fertig" markiert haben, kontaktieren Sie uns bitte.<br><br><ul><li>Für jede einzelne Grafikposition muss eine Datei hochgeladen werden.</li><li>Bitte laden Sie Ihren Grafikablauf hoch!</li><li>Das Druckmaß finden Sie hier in der Cloud, in Ihrer Standskizze oder dem technischen Datenblatt.</li><li>Die Deadline zum Hochladen erhalten Sie per Email.</li><li>Druckcloud als „fertig“ markieren, wenn alles hochgeladen wurde.</li><li>Der Grafikablauf muss Halle und Standnummer enthalten sowie die illustrierte Anordnung der Grafik.</li><li>Die Cloud versendet automatisch Reminder bis die Cloud als „fertig“ markiert wird.</ul>',
      internal_print_cloud_introduction: 'Willkommen in der Druckverwaltung von Lüco. Bitte laden Sie für jeden Druck ein Logo oder eine Grafik hoch. Wenn Sie alle Dateien hochgeladen haben, markieren Sie Ihren Vorgang als "Fertig", so dass wir mit dem Druck beginnen können. Wenn Sie einen Fehler entdecken und Ihren Vorgang schon als "Fertig" markiert haben, kontaktieren Sie uns bitte.<br><br><ul><li>Für jede einzelne Grafikposition muss eine Datei hochgeladen werden.</li><li>Bitte laden Sie Ihren Grafikablauf hoch!</li><li>Das Druckmaß finden Sie hier in der Cloud, in Ihrer Standskizze oder dem technischen Datenblatt.</li><li>Die Deadline zum Hochladen erhalten Sie per Email.</li><li>Druckcloud als „fertig“ markieren, wenn alles hochgeladen wurde.</li><li>Der Grafikablauf muss Halle und Standnummer enthalten sowie die illustrierte Anordnung der Grafik.</li><li>Die Cloud versendet automatisch Reminder bis die Cloud als „fertig“ markiert wird.</ul>',
      print_cloud_introduction: 'Willkommen in der Druckverwaltung von Lüco. Bitte laden Sie für jeden Druck ein Logo oder eine Grafik hoch. Wenn Sie alle Dateien hochgeladen haben, markieren Sie Ihren Vorgang als "Fertig", so dass wir mit dem Druck beginnen können. Wenn Sie einen Fehler entdecken und Ihren Vorgang schon als "Fertig" markiert haben, kontaktieren Sie uns bitte.',
      stand_type_selection: 'Wenn Sie vor der Rückwand stehen und die offene Ecke befindet sich auf Ihrer rechten Seite, haben Sie einen „Eckstand rechts“, wenn sich die offene Ecke auf Ihrer linken Seite befindet, haben Sie einen „Eckstand links“.',
      upload_files_for_every_print: 'Bitte laden Sie für jeden Druck ein Logo oder eine Grafik hoch. Erst wenn für jeden Druck eine Datei hochgeladen wurde, können Sie den Vorgang als "Fertig" markieren.',
      upload_files_later: 'Ihre Druckdateien können Sie später in einem gesonderten Bereich, der DruckCloud, hochladen.',
    },
    form: {
      errors: {
        booth_draft: 'Keinen Grafikablauf ausgewählt',
        graphic_design: 'Keine Fläche ausgewählt',
        lettering: 'Es wurde keine Beschriftung eingegeben',
        print_article: 'Kein Druckartikel ausgewählt',
        print_article_late: 'Druckartikel auf Anfrage',
        spanning_mode: 'Kein Druckmodus ausgewählt',
      },
      labels: {
        choose_surface: 'Flächen auswählen',
        seamless_print: 'Nahtloser Druck',
        seamless_print_with_note: 'Nahtloser Druck (Es müssen min. 2 Flächen ausgewählt werden)',
        choose_size: 'Größe des Druckes in Quadratmeter',
        current_print_article: 'Aktueller Druckartikel',
        current_surface: 'Aktuelle Fläche',
        drag_and_drop_file: 'Datei reinziehen',
        hint_lettering: 'Beschriftung',
        hint_print: 'Druck',
        how_to_order_graphics: 'Wie bestelle ich Grafik?',
        lettering: 'Beschriftung*',
        lettering_across_all_surfaces: 'Beschriftung flächenübergreifend',
        lettering_per_surface: 'Beschriftung pro Fläche',
        notes: 'Hinweise',
        no_options: 'Die ausgewählten Flächen besitzen keinen gemeinsamen Druckartikel',
        no_options_last_minute: 'Druckartikel auf Anfrage',
        or: 'ODER',
        per_surface: 'pro Fläche',
        please_select: 'Bitte auswählen',
        print_across_all_surfaces: 'Druck flächenübergreifend',
        print_article: 'Druckartikel',
        print_per_surface: 'Druck pro Fläche',
        select_file: 'Datei auswählen',
        select_print_article: 'Druckartikel auswählen',
        selected_file: 'Ausgewählte Datei',
        spanning_mode: 'Druckflächenzuordnung',
        spanning_mode_hint: '(*Wandfüllungen nicht nahtlos bedruckbar)',
        single_surface: 'Fläche',
        surface: 'Flächen',
        surface_selected: 'Fläche ausgewählt',
        surfaces_selected: 'Flächen gewählt',
      },
      placeholders: {
        please_select: 'Bitte auswählen',
        please_select_surface_first: 'Bitte zuerst Fläche auswählen'
      },
    },
    headings: {
      basket_reorder: 'Warenkorb Nachbestellung',
      booth_package: 'Standbaupaket',
      booth_draft_optional: 'Grafikablauf Kunde',
      booth_draft_required: 'Pflichfeld',
      graphic_design: 'Weitere grafische Gestaltung',
      graphic_design_deadline: 'Deadline zum Upload der Druckdaten erhalten Sie in Ihrer Auftragsbestätigung',
      information: 'Information',
      lettering: 'Standbeschriftung/ -grafiken',
      lettering_required: 'Standbeschriftung/ -grafiken (Pflichtfeld)',
      printable_article: 'Bedruckbarer Artikel',
      print_configuration: 'Druckkonfiguration',
      print_cloud: 'Lüco Druckverwaltung',
      summary: 'Zusammenfassung',
      print_job_requests: 'Druckauftrag-Versionen'
    },
    indicators: {
      check_availability: 'Verfügbarkeiten werden überprüft',
      delete_upload: 'Upload wird gelöscht',
      mark_as_user_ready: 'Vorgang wird als "Fertig" markiert',
      one_moment_please: 'Einen Moment bitte',
      remove_booth_draft: 'Grafikablauf wird gelöscht',
      submit_order: 'Bestellungsanfrage wird verarbeitet',
      update_lettering: 'Die Standbeschriftung wird aktualisiert',
      update_print_article: 'Der Druckartikel wird aktualisiert',
      update_surface: 'Fläche wird aktualisiert',
      upload: 'Datei wird hochgeladen',
    },
    labels: {
      article: 'Artikel',
      articles: 'Artikel',
      basket: 'Warenkorb',
      booth_package: 'Standpaket',
      booth_type: 'Standart',
      characters_inclusive: 'Zeichen inklusive',
      company: 'Firma',
      count: 'Anzahl',
      dimensions: 'Maße',
      exhibition_booth_number: 'Messestandnummer',
      exhibition_hall: 'Messe-Halle',
      in_basket: 'Im Warenkorb',
      booth_draft: 'Grafikablauf',
      no_booth_draft_uploaded: 'Kein Grafikablauf hochgeladen',
      no_prints_selected: 'Sie haben keine Drucke ausgewält',
      no_surfaces_selected: 'Es wurden bisher keine Flächen ausgewählt',
      price_current: 'Aktueller Preis',
      price_new: 'Neuer Preis',
      printing_information: 'Druckhinweise',
      upload_file_later: 'Die Grafikdatei kann zu einem späteren Zeitpunkt hochgeladen werden',
      upload_missing: 'Grafikdatei fehlt',
      file_missing: 'Datei konnte nicht gefunden werden',
      file_missing_reupload: 'Datei konnte nicht gefunden werden. Bitte laden Sie es erneut hoch.',
      deleted: 'Gelöscht',
      required_surface: 'Diese Fläche kann nicht geändert werden, da es sich um eine Pflichtfläche handelt.',
      no_alternative_print_articles: 'Es sind keine alternativen Druckartikel für diese Fläche verfügbar.',
      no_alternative_surfaces: 'Es sind keine Alternativflächen mit gleichem Druckartikel verfügbar.',
      no_documents_available: 'Keine Dokumente verfügbar.',
      no_information: 'Keine Angabe'
    },
    modals: {
      titles: {
        add_graphic_design: 'Grafische Gestaltung hinzufügen',
        add_lettering: 'Standbeschriftung hinzufügen',
        add_more_printable_articles: 'Weitere bedruckbare Artikel hinzufügen',
        add_print: 'Druck hinzufügen',
        article_description: 'Artikelbeschreibung',
        edit_lettering: 'Standbeschriftung bearbeiten',
        edit_print_article: 'Druckartikel bearbeiten',
        edit_surface: 'Fläche bearbeiten',
        upload_booth_draft: 'Grafikablauf hochladen',
        upload_graphic_file: 'Grafikdatei hochladen'
      }
    },
    notices: {
      messages: {
        articles_without_print: 'Sie haben nicht für alle bedruckbaren Artikel einen Druck ausgewählt. Wollen Sie trotzdem fortfahren? Sie können die Drucke zu einem späteren Zeitpunkt nachbestellen. Weitere Informationen diesbezüglich erhalten im Anschluss der Bestellung per E-Mail.',
        delete_upload: 'Wollen Sie den Upload wirklich löschen?',
        lettering: 'Sie müssen zuerst eine Standbeschriftung für die grafische Gestaltung auswählen, bevor Sie den Bestellvorgang fortsetzen können.',
        lettering_selected: 'Ausgewählt',
        minimum_square_meter: 'Dieses Standbaupaket kann erst ab einer Fläche von [SQUARE_METER] Quadratmetern ausgewählt werden.',
        missing_graphic_files: 'Sie haben noch nicht für jeden Druck eine Grafik hochgeladen. Wollen Sie trotzdem fortfahren? Sie können die fehlenden Grafiken noch zu einem späteren Zeitpunkt hochladen. Weitere Informationen diesbezüglich erhalten im Anschluss der Bestellung per E-Mail.',
        minimum_checkout: 'Bitte wählen Sie ein Standpaket oder mindestens einen Zusatzartikel aus, bevor Sie Ihre Bestellung abschicken können.',
        remove_booth_draft: 'Wollen Sie den Grafikablauf wirklich löschen?',
        remove_print_article: 'Wollen Sie den Druckartikel wirklich aus dem Warenkorb entfernen?'
      },
      titles: {
        articles_without_print: 'Artikel ohne Druck',
        booth_package_selection: 'Standpaketauswahl',
        delete_upload: 'Upload löschen',
        lettering: 'Standbeschriftung',
        missing_graphic_files: 'Fehlende Grafiken',
        minimum_checkout: 'Leerer Warenkorb',
        remove_booth_draft: 'Grafikablauf löschen',
        remove_print_article: 'Druckartikel entfernen',
      },
      warnings: {
        article_removed: 'Dieser Artikel wurde aus dem Sortiment der Messe entfernt. Bitte kontaktieren Sie den Support.',
        missing_print_article: '[ARTICLE_NAME] für "[ARTICLE_PRINT_NAME]" wurde aus dem Sortiment der Messe entfernt.',
        no_print_articles_available: 'Es können keine weitere Drucke hinzugefügt werden. Bitte kontaktieren Sie den Support',
        not_bookable_print_article: '[ARTICLE_NAME] für "[ARTICLE_PRINT_NAME]" kann nicht mehr bestellt werden.'
      }
    },
    tables: {
      columns: {
        file: 'Datei',
        graphic_file: 'Grafikdatei',
        lettering_graphic_file: 'Beschriftung/Grafikdatei',
        price: 'Preis',
        price_per_piece: 'Preis pro Stück',
        print_article: 'Druckartikel',
        print_dimensions: 'Druckmaße',
        surface: 'Fläche',
        count: 'Anzahl',
        date: 'Datum',
      }
    },
    toasts: {
      messages: {
        booth_draft: 'Grafikablauf erfolgreich hochgeladen',
        booth_draft_deleted: 'Grafikablauf erfolgreich gelöscht',
        lettering_updated: 'Standbeschriftung erfolgreich aktualisiert',
        mark_as_ready: 'Der Vorgang wurde erfolgreich als "Fertig" markiert',
        print_article_updated: 'Druckartikel erfolgreich aktualisiert',
        surface_updated: 'Fläche erfolgreich aktualisiert',
        upload_deleted: 'Grafikdatei erfolgreich gelöscht',
        upload_successful: 'Grafikdatei erfolgreich hochgeladen'
      },
      errors: {
        booth_draft: 'Grafikablauf konnte nicht hochgeladen werden',
        booth_draft_deleted: 'Grafikablauf konnte nicht gelöscht werden',
        lettering_updated: 'Standbeschriftung konnte nicht aktualisiert werden',
        mark_as_ready: 'Der Vorgang konnte nicht als "Fertig" markiert werden',
        print_article_updated: 'Druckartikel konte nicht aktualisiert werden',
        surface_updated: 'Fläche konnte nicht aktualisiert werden',
      }
    }
  }
}